export enum ExerciseType {
  ZONE2 = 'zone2',
  HIIT = 'hiit',
  SPRINT = 'sprint',
  ENDURANCE = 'endurance',
  INTERVAL = 'interval',
  TEMPO = 'tempo',
  LIFT = 'lift',
  MOBILITY = 'mobility',
  FUNCTIONAL = 'functional',
  PLYOMETRIC = 'plyometric',
  AGILITY = 'agility',
  RECOVERY = 'recovery',
  REHAB = 'rehab',
  WARMUP = 'warmup',
  COOLDOWN = 'cooldown',
  STABILITY = 'stability',
  BODYWEIGHT = 'bodyweight',
  ACTIVATION = 'activation',
  STRETCH = 'stretch',
  CONDITIONING = 'conditioning',
  ISOMETRIC = 'isometric',
  WARM_UP = 'warm-up'
}

export interface Exercise {
  id: string;
  name: string;
  description?: string;
  muscle_group?: string;
  equipment?: string;
  type: ExerciseType;
  image_url?: string;
}

export interface ExerciseReadDTO {
  id: string;
  name: string;
  description?: string;
  muscle_group?: string;
  equipment?: string;
  type: ExerciseType;
  image_url?: string;
}

export interface ExerciseCreateDTO {
  name: string;
  description?: string;
  muscle_group?: string;
  equipment?: string;
  type: ExerciseType;
  image_url?: string;
}

export interface ExerciseUpdateDTO {
  id: string;
  name?: string;
  description?: string;
  muscle_group?: string;
  equipment?: string;
  type?: ExerciseType;
  image_url?: string;
}

export interface ExerciseSearchResult {
  exercise: ExerciseReadDTO;
  similarity_score: number;
}

